import subdomainStyles from "../../subdomainStyles.json";
import {setCookie, getCookie, getSubdomain} from "../general";


const STYLE_COOKIE_NAME = 'sub-styles'

export const updateSiteStyleVariables = (styleData) => {

    let svars = [
        'primary-color',
        'secondary-color',
        'success-color',
        'warning-color',
        'danger-color',
        'homepage-bg',
        'homepage-subtitle',
        'homepage-title',
        'logo-light-src',
        'logo-dark-src',
        'homepage-bg',
        'loan-estimate-page',
        'contact-phone',
        'contact-email',
        'org-home-link',
    ]

    svars = svars.filter(d => Object.keys(styleData).includes(d))

    const cookieObj = {}

    svars.forEach(v => {
        cookieObj[v] = styleData[v]

        if (['homepage-bg', 'logo-light-src', 'logo-dark-src'].includes(v)) {
            document.documentElement.style.setProperty(`--${v}`, `url("${styleData[v]}")`);
        } else {
            document.documentElement.style.setProperty(`--${v}`, styleData[v]);
        }

    })
    setCookie(STYLE_COOKIE_NAME, JSON.stringify(cookieObj), 365);

}



export const pullSubdomainStyleFromCookie = () => {
    let cookiedata = getCookie(STYLE_COOKIE_NAME)
    if (cookiedata && cookiedata !== "") {
        const styles = JSON.parse(cookiedata)
        return styles
    }
    return {}
}


export const pullLoanEstimatePageFromCookie = () => {
    let cookiedata = getCookie(STYLE_COOKIE_NAME)
    if (cookiedata && cookiedata !== "") {
        const data = JSON.parse(cookiedata)
        return data['loan-estimate-page']
    }
}



